export default __webpack_public_path__ + "static/media/0054.56d3c444.png";